
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../../mcss/main.css";
import ActivityLog from '../../ActivityLog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import Tran_data_unlock_request from '../../Tran_data_unlock_request';


function ModificationTranctionCardExecutivePurpose() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");
    const userSrno = sessionStorage.getItem("userSrno");

    const [filtertransaction, setFiltertransaction] = useState('');
    const [onceRun, setOnceRun] = useState(false);
    const [pProductList, setPProductList] = useState([]);
    const [commValue, setCommValue] = useState("");
    const [pAgent, setPAgent] = useState(null);
    const [ppLocationValue, setPPLocationValue] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [ppLocation, setPPLocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [hdrLocation, setHdrLocation] = useState("");
    const [filterSrno, setFilterSrno] = useState("");
    const [commissionDataToDelete, setCommissionDataToDelete] = useState([]);
    const [editbtnView, setEditbtnView] = useState(true);
    const [isSaveDialogOpen, setSaveDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const [saveMsgTextYN, setSaveMsgTextYN] = useState("Are you sure you want to save?");
    const [deleteMsgTextYN, setDeleteMsgTextYN] = useState("Are you sure you want to delete?");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);
    // const [headerList, setHeaderList] = useState([]);
    const [editbtnHeaderView, setEditbtnHeaderView] = useState(true);
    const [executive, setExecutive] = useState([]);
    const [subExecutive, setSubExecutive] = useState([]);
    const [executiveCode, setExecutiveCode] = useState(0);
    const [executiveName, setExecutiveName] = useState(0);
    const [subExecutiveCode, setSubExecutiveCode] = useState(0);
    const [subExecutiveName, setSubExecutiveName] = useState(0);
    const [saveData, setSaveData] = useState(null);
    const [purpose, setPurpose] = useState(null);
    const [purposeCode, setPurposeCode] = useState(0);
    const [cardno, setCardno] = useState('')
    const [radioType, setRadioType] = useState('');
    const [compareObj, setCompareObj] = useState(null);
    const [loanaccno, setLoanaccno] = useState('')

    const [showFilter, setShowFilter] = useState(true);
    const [isd, setIsd] = useState([]);
    const [isdCode, setIsdCode] = useState('');
    const [countryDetails, setCountryDetails] = useState([]);
    const [country, setCountry] = useState(null);
    const [countryCode, setCountryCode] = useState(0);
    const [countryName, setCountryName] = useState("");
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [unlockRequestType, setUnlockRequestType] = useState("");


    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setPPLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRANSACTION_MODIFICATION_CARD_EXECUTIVE_PURPOSE'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
    }, []);
    const handleLocationChange = (value) => {
        setPPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPPLocationValue(location[1]);
        setHdrLocation(location[2]);
        setPProductList([]);
        setEditbtnHeaderView(true)
        sessionStorage.activeBranch = location[1];
    }

    const applyFilter = () => {
        $(".loader").show();
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        !ppLocationValue && (msg[i++] = 'Location.')
        !filtertransaction && (msg[i++] = 'Transaction.')
        !radioType && (msg[i++] = 'Modification.')
        !filterSrno && (msg[i++] = 'Srno .')
        if (i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var obj = {
                location: ppLocationValue,
                transaction: filtertransaction,
                filterSrno: filterSrno,
                modificationType: radioType,
            }
            Common.callApi(Common.apiDetailsModification, [sid, "getlist", JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                // console.log(resp);
                if (resp.trandetailproduct.length > 0) {
                    setPProductList(resp.trandetailproduct);
                    // setHeaderList(resp.tranheader);
                    $(".loader").hide();
                    setExecutive([])
                    setSubExecutive([])
                    setExecutiveCode(0);
                    setExecutiveName('');
                    setSubExecutiveName('')
                    setPurpose(null);
                    setPurposeCode(0);
                    setCardno('');
                    setCompareData(null)
                    setSaveData(null);
                    setShowFilter(false);
                    setIsdCode('');
                    setIsd([])
                } else {
                    $(".loader").hide();
                    setPProductList([]);
                    // setHeaderList([]);
                    setMsgText("Data Not Found");
                    setMsgBox(true);
                }
                setEditbtnHeaderView(true);
            })
        }
    }

    const deleteCommission = (item) => {
        $(".loader").show();
        setDeleteDialogOpen(false);
        Common.callApi(Common.apiModiCommission, [sid, "deletecommission", JSON.stringify(item), JSON.stringify(tranAuditTrail)], function (result) {
            let resp = JSON.parse(result);
            setPProductList(resp.trandetailproduct);
            setTranAuditTrail([]);
            $(".loader").hide();
            // setCommissionDisable(true);
            setPProductList(prevData =>
                prevData.map(row =>
                    row.uniquekey === item.uniquekey
                        ? { ...row, commission_disable: "1" }
                        : row
                )
            );
            setMsgText("Success");
            setMsgBox(true);
            setEditbtnView(true);
        })

    }

    const saveHandler = () => {
        $(".loader").show();
        setSaveDialogOpen(false);
        console.log(pProductList, compareObj)
        //stuck here 
        const compareToWhomeObj = pProductList.filter(item => item.prd_line_no === compareObj.prd_line_no);
        const infoObject = Common.compareArrays(compareToWhomeObj, [compareObj]);
        console.log(infoObject);

        const a = Common.addInfoToAuditTrail(tranAuditTrail, infoObject, filtertransaction, ppLocationValue)
        console.log(a);
        console.log(tranAuditTrail);

        setTranAuditTrail(a);
        Common.callApi(Common.apiDetailsModification, [sid, "updateData", JSON.stringify(saveData), JSON.stringify(a)], function (result) {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.status) {
                setPProductList(resp.trandetailproduct);
                setMsgText("Success");
                setMsgBox(true);
                setEditbtnView(true);
                setTranAuditTrail([]);
                setSaveData(null);
                setCompareObj(null)
                setSubExecutive([]);
                setExecutive([]);
                expireUnlock();
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }

        });
    };

    const handleEditRequest = (item) => {
        const currDate = new Date();
        const newViewDate = item?.prd_date;//prd_date=2026-04-08
        const newCurrDate = Common.dateYMD(currDate);
        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        const obj = {
            srno: filterSrno,
            type: filtertransaction,
            pageright: 'TRANSACTION_MODIFICATION_CARD_EXECUTIVE_PURPOSE',
            location: ppLocationValue
        }
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                handleEditRequest1();
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: filtertransaction, trannumber: filterSrno, location: ppLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    const expireUnlock = () => {
        if (unlockRequestType !== "SELF") {
            const obj = {
                srno: filterSrno,
                type: filtertransaction,
                status: 'E',
                currentDate: Common.dateYMD(new Date()),
                pageright: 'TRANSACTION_MODIFICATION_CARD_EXECUTIVE_PURPOSE'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const handleEditRequest1 = () => {
        setEditbtnView(false);
    };

    const saveBtnHandler = (item) => {
        if (radioType === 'COUNTRY') {
            if (country === null) {
                setMsgText("Please Select Country.");
                setMsgBox(true);
            } else {
                let remark = `Country changed from ${countryDetails[0].country} to ${countryName}.`;
                const obj = {
                    srno: item.hdr_srno,
                    type: item.hdr_type,
                    spLocationValue: item.hdr_location,
                    cntsrno: countryCode,
                    location: ppLocationValue,
                    transaction: filtertransaction,
                    filterSrno: filterSrno,
                    modificationType: radioType,
                    nDepDate: item.hdr_departure_date,
                    nCountry: country,
                    nTraveller: { id: item.id },
                    indsrno: item.hdr_individual,
                    usdAmtCN: item.prd_usd_amount,
                    lineNo: item.prd_line_no,
                    remark: remark,
                };

                console.log(pProductList)
                //stuck here 
                const compareToWhomeObj = pProductList.filter(item => item.prd_line_no === obj.lineNo);

                const infoObject = Common.compareArrays(compareToWhomeObj, [{ ...compareToWhomeObj[0], country: country?.label }]);
                console.log(infoObject);

                const a = Common.addInfoToAuditTrail(tranAuditTrail, infoObject, filtertransaction, ppLocationValue)
                console.log(a);
                console.log(tranAuditTrail);
                setTranAuditTrail(a);
                Common.callApi(Common.apiDetailsModification, [sid, 'updateCountry', JSON.stringify(obj), JSON.stringify(a)], (result) => {
                    let resp = JSON.parse(result);
                    if (resp.msg !== "") {
                        expireUnlock();
                        setCountryDetails(resp.countryArr);
                        setCountry(null);
                        setEditbtnView(true);
                        setMsgText(resp.msg);
                        setMsgBox(true);
                    } else {
                        setMsgText(resp.msgCode);
                        setMsgBox(true);
                    }
                });
            }
        } else {
            // if (radioType === 'PURPOSE') {
            //     const parts = purpose.id.split('^');
            //     if (parts[1] === '20' && !(item.hdr_residential === "2" || item.hdr_residential === "4")) {//Purpose=20 means RECONVERSION and "Non-Resident Indian=2,"Foreigners-Tourist"=4
            //         let msg = "'RECONVERSION' purpose is only allowed for foreign-tourist/Non-Resident Indian.";
            //         setMsgText(msg);
            //         setMsgBox(true);
            //     } else if (parts[1] != '20' && item.hdr_residential === "4") {
            //         let msg = " For foreign-tourist only 'RECONVERSION' purpose is allowed.";
            //         setMsgText(msg);
            //         setMsgBox(true);
            //     }
            // } else {
            //     let remark = "Transaction Modify";
            //     console.log(item);
            //     var obj = {
            //         location: item.prd_location,
            //         transaction: item.prd_type,
            //         filterSrno: item.prd_srno,
            //         modificationType: radioType,
            //         executiveCode: executiveCode,
            //         executiveName: executiveName,
            //         subExecutiveCode: subExecutiveCode,
            //         subExecutiveName: subExecutiveName,
            //         purposeCode: purposeCode,
            //         cardno: cardno,
            //         lineno: item.prd_line_no,
            //         isd: isdCode,
            //     }
            //     const updatedObj = {
            //         ...item,
            //     };
            //     if (radioType === 'CARD' && cardno != '') {
            //         remark = `Card Number Change from ${updatedObj?.prd_card_no} to ${cardno} . `;
            //         updatedObj.prd_card_no = cardno;
            //     }
            //     if (radioType === 'PURPOSE' && purpose) {
            //         const parts = purpose.id.split('^');
            //         remark = `Purpose Change from ${updatedObj?.hdr_purpose + ' ' + updatedObj?.purpose_name} to ${purpose.label} . `;
            //         updatedObj.hdr_purpose = parts[1];
            //         updatedObj.purpose_name = parts[2];
            //     }
            //     if (radioType === 'EXECUTIVE' && executive.length > 0) {
            //         const parts = executive[item.prd_line_no].id.split('^');
            //         remark = `Executive Change from ${updatedObj?.hdr_executive + ' ' + updatedObj?.me_employee} to ${executive[item.prd_line_no]?.label} . `;
            //         updatedObj.hdr_executive = parts[1];
            //         updatedObj.me_employee = parts[2];
            //     }
            //     if (radioType === 'SUBEXECUTIVE' && subExecutive.length > 0) {
            //         const parts = subExecutive[item.prd_line_no].id.split('^');
            //         remark = `Sub Executive Change from ${updatedObj?.hdr_sub_executive + ' ' + updatedObj?.mes_employee} to ${subExecutive[item.prd_line_no]?.label} . `;
            //         updatedObj.hdr_sub_executive = parts[1];
            //         updatedObj.mes_employee = parts[2];
            //     }
            //     if (radioType === 'ISD' && isd.length > 0) {
            //         remark = `Currency Change from ${updatedObj?.prd_isd} to ${isdCode} . `;
            //         updatedObj.prd_isd = isdCode;
            //     }
            //     console.log(remark);
            //     updatedObj.remark = remark;
            //     obj.remark = remark;
            //     setCompareObj(updatedObj);
            //     setSaveData(obj)
            //     setSaveDialogOpen(true);
            // }
            if (radioType === 'PURPOSE') {
                const parts = purpose.id.split('^');
                if (parts[1] === '20' && !(item.hdr_residential === "2" || item.hdr_residential === "4")) {//Purpose=20 means RECONVERSION and "Non-Resident Indian=2,"Foreigners-Tourist"=4
                    let msg = "'RECONVERSION' purpose is only allowed for foreign-tourist/Non-Resident Indian.";
                    setMsgText(msg);
                    setMsgBox(true);
                    return;
                } else if (parts[1] != '20' && item.hdr_residential === "4") {
                    let msg = " For foreign-tourist only 'RECONVERSION' purpose is allowed.";
                    setMsgText(msg);
                    setMsgBox(true);
                    return;
                }
            }
            let remark = "Transaction Modify";
            console.log(item);
            var obj = {
                location: item.prd_location,
                transaction: item.prd_type,
                filterSrno: item.prd_srno,
                modificationType: radioType,
                executiveCode: executiveCode,
                subExecutiveCode: subExecutiveCode,
                executiveName: executiveName,
                subExecutiveName: subExecutiveName,
                purposeCode: purposeCode,
                cardno: cardno,
                lineno: item.prd_line_no,
                isd: isdCode,
                loanaccno: loanaccno

            }
            const updatedObj = {
                ...item,
            };

            if (radioType === 'CARD' && cardno != '') {
                remark = `Card Number Change from ${updatedObj?.prd_card_no} to ${cardno} . `;
                updatedObj.prd_card_no = cardno;
            }
            if (radioType === "LOANACCNO" && loanaccno != '') {
                remark = `Card Number Change from ${updatedObj?.hdr_loan_account_no} to ${loanaccno} . `;
                updatedObj.hdr_loan_account_no = loanaccno;
            }
            if (radioType === 'PURPOSE' && purpose) {
                const parts = purpose.id.split('^');
                remark = `Purpose Change from ${updatedObj?.hdr_purpose + ' ' + updatedObj?.purpose_name} to ${purpose.label} . `;
                updatedObj.hdr_purpose = parts[1];
                updatedObj.purpose_name = parts[2];
            }

            if (radioType === 'EXECUTIVE' && executive.length > 0) {
                const parts = executive[item.prd_line_no].id.split('^');
                remark = `Executive Change from ${updatedObj?.hdr_executive + ' ' + updatedObj?.me_employee} to ${executive[item.prd_line_no]?.label} . `;
                updatedObj.hdr_executive = parts[1];
                updatedObj.me_employee = parts[2];
            }
            if (radioType === 'SUBEXECUTIVE' && subExecutive.length > 0) {
                const parts = subExecutive[item.prd_line_no].id.split('^');
                remark = `Sub Executive Change from ${updatedObj?.hdr_sub_executive + ' ' + updatedObj?.mes_employee} to ${subExecutive[item.prd_line_no]?.label} . `;
                updatedObj.hdr_sub_executive = parts[1];
                updatedObj.mes_employee = parts[2];
            }
            if (radioType === 'ISD' && isd.length > 0) {
                remark = `Currency Change from ${updatedObj?.prd_isd} to ${isdCode} . `;
                updatedObj.prd_isd = isdCode;
            }
            console.log(remark);
            updatedObj.remark = remark;
            obj.remark = remark;
            setCompareObj(updatedObj);
            setSaveData(obj)
            setSaveDialogOpen(true);
        }
    }

    const btnActivityLog = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.prd_type, trannumber: item.prd_srno, trancategory: "T", location: item.prd_location, subtranno: item.prd_line_no || 0 });
    }

    const btnActivityLogCountry = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.hdr_type, trannumber: item.hdr_srno, trancategory: "T", location: item.hdr_location });
    }

    const handleRadioChange = (value) => {
        setRadioType(value);
    }

    const handleExecutive = (value, item) => {
        console.log(value);
        executive[item.prd_line_no] = value;
        setExecutive([...executive]);
        const exec = value.id.split('^');
        setExecutiveCode(exec[1]);
        setExecutiveName(exec[2]);

    }
    const handleSubExecutive = (value, item) => {
        console.log(value);
        subExecutive[item.prd_line_no] = value;
        setSubExecutive([...subExecutive]);
        const exec = value.id.split('^');
        setSubExecutiveCode(exec[1]);
        setSubExecutiveName(exec[2]);
    }

    const handleRepPurposeChange = (value) => {
        console.log("This is Purpose Picklist!", value);
        setPurpose(value);
        const pur = value.id.split('^');
        setPurposeCode(pur[1]);
    }

    const cardnoHandler = (e) => {
        const value = e.target.value;
        setCardno(value);
    }

    const handleBack = (e) => {
        setEditbtnView(true);
        setShowFilter(true);
    }

    const handleChangeIsd = (value, item) => {
        isd[item.prd_line_no] = value;
        setIsd([...isd]);
        let a = value.id.split("^");
        setIsdCode(a[1]);
        // setPIsdId(a[1]);
        //pendgin in future if we have to show 
        // const obj = {
        //     isd: a[1],
        //     location: pbLocationValue,
        //     product: pProduct
        // }
        // Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
        //     let resp = JSON.parse(result);
        //     setPRate(resp.buyrate * 1);
        //     setMaxPRate(resp.maxbuyrate * 1);
        //     setMinPRate(resp.minbuyrate * 1);
        //     setUsdRate(resp.usdratebuy * 1);
        // });
    }

    const applyFilterCountry = () => {
        $(".loader").show();
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        !ppLocationValue && (msg[i++] = 'Location.')
        !filtertransaction && (msg[i++] = 'Transaction.')
        !filterSrno && (msg[i++] = 'Srno .')
        if (i > 1) {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: ppLocationValue,
                transaction: filtertransaction,
                filterSrno: filterSrno,
                modificationType: radioType,
            }
            Common.callApi(Common.apiDetailsModification, [sid, "getCountryDetails", JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                console.log(resp);
                $(".loader").hide();
                setCountryDetails(resp);
                setPProductList(resp);
                setShowFilter(false);
            });
        }
    }

    const handleCountryValue = (value) => {
        setCountry(value);
        const cnt = value.id.split('^');
        setCountryCode(cnt[1]);
        setCountryName(cnt[2]);
    }

    return (

        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Transaction Modification Card Number/Executive/Sub Executive/Purpose </h3>
                    </Col>
                </Row>
                {showFilter ?
                    <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={ppLocation}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleLocationChange}
                                        styles={{
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: 300, // adjust height as needed to fit ~8 options
                                            }),
                                        }}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className="col-md-3 col-6">
                                <Form.Label>Transaction</Form.Label>
                                <Form.Select
                                    value={filtertransaction}
                                    onChange={(e) => {
                                        setFiltertransaction(e.target.value);
                                    }}>
                                    <option value="">Select</option>
                                    <option value="PP">PP</option>
                                    <option value="PB">PB</option>
                                    <option value="SP">SP</option>
                                    <option value="SB">SB</option>
                                    <option value="CNOUT">CN OUT</option>
                                    <option value="CNIN">CN IN</option>
                                </Form.Select>
                            </Col>
                            <Col >
                                <Form.Label>Modification</Form.Label>
                                {
                                    filtertransaction === "SP" ? <>
                                        <Form.Check
                                            checked={radioType === "CARD"}
                                            onChange={() => handleRadioChange("CARD")}
                                            type="radio"
                                            label="Card Number"
                                        />
                                        <Form.Check
                                            checked={radioType === "PURPOSE"}
                                            onChange={() => handleRadioChange("PURPOSE")}
                                            type="radio"
                                            label="Purpose"
                                        />
                                        <Form.Check
                                            checked={radioType === "COUNTRY"}
                                            onChange={() => handleRadioChange("COUNTRY")}
                                            type="radio"
                                            label="Country"
                                        />
                                        <Form.Check
                                            checked={radioType === "LOANACCNO"}
                                            onChange={() => handleRadioChange("LOANACCNO")}
                                            type="radio"
                                            label="Loan Account No"
                                        />
                                    </> : null
                                }
                                <Form.Check
                                    checked={radioType === "EXECUTIVE"}
                                    onChange={() => handleRadioChange("EXECUTIVE")}
                                    type="radio"
                                    label="Executive"
                                />
                                <Form.Check
                                    checked={radioType === "SUBEXECUTIVE"}
                                    onChange={() => handleRadioChange("SUBEXECUTIVE")}
                                    type="radio"
                                    label="Sub Executive"
                                />
                                <Form.Check
                                    checked={radioType === "ISD"}
                                    onChange={() => handleRadioChange("ISD")}
                                    type="radio"
                                    label="ISD"
                                />
                                {/* {filtertransaction === "SP" &&  
                                    <Form.Check
                                        checked={radioType === "CNOUT"}
                                        onChange={() => handleRadioChange("RATE")}
                                        type="radio"
                                        label="Rate"
                                    />
                                } */}
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={10} value={filterSrno} onChange={e => Common.validateNumValue(e.target.value, setFilterSrno)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                {
                                    radioType === 'COUNTRY' ?
                                        <>
                                            <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={applyFilterCountry}> List</Button>
                                        </> :
                                        <>
                                            <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={applyFilter}> List</Button>
                                        </>
                                }
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </>
                    : <>
                        <Row>
                            <Col>
                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={handleBack}>Back</Button>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row></Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Table responsive bordered striped>
                                {
                                    radioType === 'COUNTRY' ?
                                        <>
                                            <thead>
                                                <tr>
                                                    <th>Sr No</th>
                                                    <th>Location</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                    <th>Country</th>
                                                    <th>Individual</th>
                                                    <th>Corporate</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {countryDetails.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        {/* Product Row */}
                                                        <tr>
                                                            <td>{item.hdr_srno}</td>
                                                            <td>{item.location}</td>
                                                            <td>{item.hdr_type}</td>
                                                            <td>{item.hdr_date}</td>
                                                            <td>{item.country}</td>
                                                            <td>{item.name}</td>
                                                            <td>{item.ledger}</td>
                                                            {/* <td></td> */}
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="13" >
                                                                <Table responsive bordered striped style={{ width: '100%' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            {radioType === "COUNTRY" &&
                                                                                <td >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Country<span className="text-danger">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            isDisabled={editbtnView}
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={country}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={Picklist.fetchCountryPicklist}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleCountryValue}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </td>
                                                                            }
                                                                            <td className='col-md-1 col-6'>
                                                                                {(userRight.edit === "1" && !editbtnView) ?
                                                                                    <Button style={{ marginRight: '10px', marginTop: '35px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => saveBtnHandler(item)}>Save</Button>
                                                                                    : null}
                                                                                {(userRight.edit === "1" && editbtnView) ?
                                                                                    <Button style={{ marginRight: '10px', marginTop: '35px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest(item)}>Edit</Button>
                                                                                    : null} &nbsp;
                                                                                <span>
                                                                                    <Badge bg="secondary" className="handCursor" onClick={() => btnActivityLogCountry(item)}>Activity Log</Badge>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </> :
                                        <>
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Isd Code</th>
                                                    <th>Isd Name</th>
                                                    <th>Denomination</th>
                                                    <th>Quantity</th>
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>USD Rate</th>
                                                    <th>USD Amount</th>
                                                    <th>Executive</th>
                                                    <th>Sub Executive</th>
                                                    <th>Purpose</th>
                                                    {radioType === "PURPOSE" && <th>Residential Status</th>}
                                                    <th>Card No</th>
                                                    {radioType === "LOANACCNO" && <th>Loan Account No</th>}
                                                    {/* <th>&nbsp;</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pProductList.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        {/* Product Row */}
                                                        <tr key={index + 'f'}>
                                                            <td>{item.prd_product}</td>
                                                            <td>{item.prd_isd}</td>
                                                            <td>{item.isd_name}</td>
                                                            <td>{item.prd_deno}</td>
                                                            <td>{item.prd_qty}</td>
                                                            <td>{item.prd_rate}</td>
                                                            <td>{item.prd_amount}</td>
                                                            <td>{item.prd_usd_rate}</td>
                                                            <td>{item.prd_usd_amount}</td>
                                                            <td>{item.hdr_executive + ' ' + item.me_employee}</td>
                                                            <td>{item.hdr_sub_executive === "0" ? '' : item.hdr_sub_executive + ' ' + item.mes_employee}</td>
                                                            <td>{item.hdr_purpose === "0" ? '' : (item.hdr_purpose + ' ' + item.purpose_name)}</td>
                                                            {radioType === "PURPOSE" && <td>{item.hdr_residential + ' ' + item.mrs_resident}</td>}
                                                            <td>{item.prd_card_no}</td>
                                                            {radioType === "LOANACCNO" && <td>{item?.hdr_loan_account_no}</td>}
                                                        </tr>

                                                        {/* Commission Row with Editable Fields */}
                                                        <tr key={index + 's'}>
                                                            <td colSpan="13" >
                                                                <Table responsive bordered striped style={{ width: '100%' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            {radioType === "EXECUTIVE" &&
                                                                                <td >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Executive<span className="text-danger">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            isDisabled={editbtnView}
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={executive[item.prd_line_no]}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={Picklist.fetchExecutivePicklist}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={(e) => handleExecutive(e, item)}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </td>
                                                                            }
                                                                            {radioType === "SUBEXECUTIVE" &&
                                                                                <td >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Sub Executive<span className="text-danger">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            isDisabled={editbtnView}
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={subExecutive[item.prd_line_no]}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={Picklist.fetchSubExecutivePicklist}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={(e) => handleSubExecutive(e, item)}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </td>
                                                                            }
                                                                            {radioType === "PURPOSE" &&
                                                                                <Col >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Purpose<span className="text-danger">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={purpose}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={Picklist.fetchPurposePicklist}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleRepPurposeChange}
                                                                                            isDisabled={editbtnView}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}

                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            }
                                                                            {radioType === "CARD" &&
                                                                                <Col >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Card No</Form.Label>
                                                                                        <Form.Control disabled={editbtnView} placeholder='Card No' type='text' value={cardno}
                                                                                            maxLength={20} onChange={cardnoHandler} />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            }
                                                                            {radioType === "ISD" &&
                                                                                <Col>
                                                                                    <Form.Group>
                                                                                        <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            isDisabled={editbtnView}
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={isd[item.prd_line_no]}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, item.prd_product)}
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={(e) => handleChangeIsd(e, item)}
                                                                                            menuPortalTarget={document.body}
                                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            }
                                                                            {radioType === "LOANACCNO" &&
                                                                                <Col >
                                                                                    <Form.Group>
                                                                                        <Form.Label>Loan Account No</Form.Label>
                                                                                        <Form.Control disabled={editbtnView} placeholder='Loan Accoutn No' type='text' value={loanaccno}
                                                                                            maxLength={50} onChange={(e) => setLoanaccno(e.target.value.trim())} />
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            }
                                                                            <td className='col-md-1 col-6'>
                                                                                {(userRight.edit === "1" && !editbtnView) ?
                                                                                    <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => saveBtnHandler(item)}>Save</Button>
                                                                                    : null}
                                                                                {(userRight.edit === "1" && editbtnView) ?
                                                                                    <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest(item)}>Edit</Button>
                                                                                    : null} &nbsp;
                                                                                <span>
                                                                                    <Badge bg="secondary" className="handCursor" onClick={() => btnActivityLog(item)}>Activity Log</Badge>
                                                                                </span>
                                                                            </td>

                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </>
                                }
                            </Table>
                        </Row>
                    </>
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <DialogYesNo isOpen={isSaveDialogOpen} onYes={(e) => saveHandler()} onNo={(e) => setSaveDialogOpen(false)}>
                {saveMsgTextYN}
            </DialogYesNo>
            <DialogYesNo isOpen={isDeleteDialogOpen} onYes={(e) => deleteCommission(commissionDataToDelete)} onNo={(e) => setDeleteDialogOpen(false)}>
                {deleteMsgTextYN}
            </DialogYesNo>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default ModificationTranctionCardExecutivePurpose;
